import styled from 'styled-components';

import { ReactComponent as Check } from 'assets/images/check.svg';
import { ReactComponent as ExchangePending } from 'assets/images/exchange-pendent.svg';
import { ReactComponent as ExclamationIcon } from 'assets/images/exclamation-circle.svg';
import { ReactComponent as XCircle } from 'assets/images/x-circle.svg';

export const Tag: any = styled.div``;
Tag.Confirmed = styled.div`
  color: #0cc665;
  font-size: 12px;
  font-weight: 600;
  border-radius: 14px;
  background: #e9fcf2;
  padding: 4px 8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;
Tag.ConfirmedIcon = styled(Check)`
  color: #0cc665;
  width: 16px;
  height: 16px;
  margin-right: 4px;
`;
Tag.Pending = styled.div`
  color: #ff7d00;
  font-size: 12px;
  font-weight: 600;
  border-radius: 14px;
  background: #fff0ca;
  padding: 4px 8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;
Tag.PendingIcon = styled(ExchangePending)`
  color: #ff7d00;
  width: 16px;
  height: 16px;
  margin-right: 4px;
`;
Tag.OutOfPolicies = styled.div`
  color: #ff2525;
  font-size: 12px;
  font-weight: 600;
  border-radius: 14px;
  background: #ffdfdf;
  padding: 4px 8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;
Tag.OutOfPoliciesIcon = styled(ExclamationIcon)`
  color: #ff2525;
  width: 16px;
  height: 16px;
  margin-right: 4px;
`;
Tag.Error = styled.div`
  color: #ff2525;
  font-size: 12px;
  font-weight: 600;
  border-radius: 14px;
  background: #ffdfdf;
  padding: 4px 8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;
Tag.ErrorIcon = styled(XCircle)`
  color: #ff2525;
  width: 16px;
  height: 16px;
  margin-right: 4px;
`;
